


































import { fetchYandexTokens } from '@/core/api/yandex-tokens'
import Vue from 'vue'

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: (): [] => [],
    },
  },
  data: () => ({
    dialog: false,
    tokens: [],
    update: {
      token: null,
    },
  }),
  watch: {
    show(newVal) {
      this.reset()
      fetchYandexTokens().then(response => {
        this.tokens = response['results']
      })
      this.dialog = newVal
    },
  },
  methods: {
    reset() {
      this.update = {
        token: null,
      }
    },
    close() {
      this.$emit('update:show', false)
    },
    submit() {
      this.$emit('submit', this.update)
      this.close()
    },
  },
})
